import "styles/pages/page-building.scss";
import React from "react";
import Layout from "components/Layout";
import Seo from "components/Seo";
import { Link } from "gatsby";

const RentPage = () => {
  return (
    <Layout is404={true}>
      <Seo title="Wynajem" />
      <section className="page-building">
        <div className="container">
          <img
            src={require("assets/images/building-img.png").default}
            className="img-img-lfuid page-building__img"
            alt=""
          />
          <h1 className="page-building__title">Strona w budowie</h1>
          <div className="page-building__text">
            Jeżeli masz pytania, skorzystaj z naszego{" "}
            <Link to="/kontakt#formularz">forumularza kontaktowego</Link>
          </div>
        </div>
        <Link to="/" className="btn btn--with-icon">
          &#171; Wróć
          <img src={require("assets/icons/vehicle-btn.svg").default} alt="" />
        </Link>
      </section>
      <div className="error-page-footer">
        <div className="container">
          <div className="error-page-footer__text">
            &copy; 2021 Elcamp RV sp. z o.o. ul. Tyniecka 118e, 30-376 Kraków
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RentPage;
